import { DetailsBooking } from 'types';
import { format } from 'date-fns';
import createLocalDateTime from '../createLocalDateTime';

const CHECK_OUT_DATE_FORMAT = "E d MMM, yyyy. 'Until' ha";

const getFormattedCheckOutDateTime = (booking: DetailsBooking) => {
  const {
    checkOut,
    property: { checkOutBefore },
  } = booking.reservation;
  const localDate = createLocalDateTime(checkOut, checkOutBefore);
  return format(localDate, CHECK_OUT_DATE_FORMAT);
};

export default getFormattedCheckOutDateTime;
